import { get, isArray, isEmpty, isPlainObject } from 'lodash';

export function sanitizeFilters(filters) {
  return Object.entries(filters).reduce((sanitized, [name, value]) => {
    if (
      // @ts-ignore
      [null, undefined].includes(value) ||
      // If its an empty array or object we remove it from filters
      ((isArray(value) || isPlainObject(value)) && isEmpty(value))
    ) {
      return sanitized;
    }

    let sanitizedValue = value;

    if (isPlainObject(value)) {
      sanitizedValue = sanitizeFilters(value);
    }

    return { ...sanitized, [name]: sanitizedValue };
  }, {});
}

export function getInitialSearch(props) {
  return {
    query: undefined,
    operator: get(props.search, 'operator', 'OR'),
    fields: get(props.search, 'fields'),
  };
}

export function getListStateKeys() {
  return ['page', 'perPage', 'search', 'sort', 'filter'];
}
